import React from "react";
import BrotherPlusPagesUsed from "../../../../components/CustomerDashboard/BrotherPlus/BrotherPlusPagesUsed/BrotherPlusPagesUsed";
import BrotherPlusPrintActivity from "../../../../components/CustomerDashboard/BrotherPlus/BrotherPlusPrintActivity/BrotherPlusPrintActivity";
import { DISPLAY_CONTENT_TYPE } from "../Dashboard";
import BenefitCard from "../../../MyDevices/components/BenefitsCard/BenefitCard";
import addSubscriptionIcon from "../../../../assets/images/mydevices/addsubscription-logo.svg"
import { useTranslation } from 'react-i18next';
import { DEVICE_ACTIONS, UPGRADE_TO_ECOPRO } from "../../../../constants/AppConstants";
import DiscountTile from "../../../../components/CustomerDashboard/BrotherPlus/DiscountTile/DiscountTile";

const MyDevicesBPlusOnlyWidgets = (props) => {
    const { BPlusTileInfo, deviceData, showEcoWidget } = props;
    const ecoProService = deviceData?.services?.ecopro;
    const brotherService = deviceData?.services?.brother;
    const isBrotherSuccess = brotherService?.isSuccess === true;
    //  Only Brother active (EcoPro not active or failed)
    const isOnlyBrotherPlusEnrolled = isBrotherSuccess && (!ecoProService || !showEcoWidget);

    const { t } = useTranslation(["translation"]);

    const benefitCards = [
        isOnlyBrotherPlusEnrolled
            ? {
                title: t('MY_DEVICES.HEADER.CANCEL_PLAN'),
                description: t('MY_DEVICES.HEADER.CANCEL_PLAN_DESCRIPTION'),
                headerIcon: null,
                bgColor: "#E9D4E9",
                cursor: "pointer",
                action: DEVICE_ACTIONS.CANCEL_PLAN,
                cname: 'cancel-plan-benefit-card'
            }
            : {
                title: t('MY_DEVICES.HEADER.ADD_SUBSCRIPTION'),
                description: t('MY_DEVICES.HEADER.SAVE_MONEY'),
                headerIcon: addSubscriptionIcon,
                bgColor: "#FCDFDF",
                cursor: "pointer",
                action: UPGRADE_TO_ECOPRO,
                cname: 'upgrade-to-ecopro-benefit-card'
            }
    ];
    const {deviceStatus, printHistoryInfo} = BPlusTileInfo

    return (
        <>
            <div className="ecorpo-brother-plus-dashboard-wrapper">
                <div className="tile tile-3">
                    <div className="box">
                        <BrotherPlusPagesUsed
                            getDeviceStatusResponse={deviceStatus}
                            displayContent={DISPLAY_CONTENT_TYPE.pagesUsedCount}
                        />
                    </div>
                    <div className="box">
                        <BrotherPlusPagesUsed
                            getDeviceStatusResponse={deviceStatus}
                            displayContent={DISPLAY_CONTENT_TYPE.duplexPagesCount}
                        />
                    </div>
                </div>
                <div className="tile tile-7">
                    <BrotherPlusPrintActivity
                        showAvgPagesUsed={true}
                        isChildComp={true}
                        BrotherPlus_printHistoryResult={printHistoryInfo}
                    />
                </div>
                <div className="tile tile-8">
                    <div className="box">
                        <BenefitCard
                            title={benefitCards[0].title}
                            description={benefitCards[0].description}
                            headerIcon={benefitCards[0].headerIcon}
                            bgColor={benefitCards[0].bgColor}
                            cursor={benefitCards[0].cursor}
                            action={benefitCards[0].action}
                            cname={benefitCards[0].cname}
                        />
                    </div>
                    <div className="box">
                        <DiscountTile />
                    </div>
                </div>

            </div>
        </>
    )
}

export default MyDevicesBPlusOnlyWidgets